import { createSlice } from '@reduxjs/toolkit';

export interface State {
  apiToken: string | null;
}

export const initialState: State = {
  apiToken: null,
};

const Auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setApiToken(state, { payload }) {
      state.apiToken = payload;
    },
  },
});

// Export slice actions
export const { setApiToken } = Auth.actions;

export default Auth.reducer;
